// extracted by mini-css-extract-plugin
module.exports = {"header":"_3WOBF4eHQXN_a-CCyaZ_Jm","cover":"_2iHwqNJYx7R4dNtISPMq5C","menu":"_3VZkI2VaTC_DsLXlaVT3OS"};